import moment from "moment";
import React, { useMemo, useState } from "react";
import { FormProvider, useFieldArray, useForm, useFormContext } from "react-hook-form";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import {
  getDefaultBill,
  renderLabelIngredientPriceHistoryOption,
} from "../../utils/Utils";
import BillOtherCreateForm from "./BillOtherCreateForm";
const BillOtherHistory = () => {
  const [watchHistory, setWatchHistory] = useState(null);
  const [view, setView] = useState({
    isViewHistory: false,
  });

  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setWatchHistory(null)
    setView({ isViewHistory: false });
  };

  const reviewHistoryMethod = useForm({
    defaultValues: getDefaultBill()
  })
  const { control } = useFormContext();
  const { fields: billHistory } = useFieldArray({
    control: control,
    name: 'billHistory',
  })

  const colTable = [

    {
      Header: "Thời gian",
      accessor: (item) => moment(item.createdAt).format('DD-MM-YYYY HH:mm:ss')
    },
    {
      Header: "Người sửa",
      accessor: (item) => item?.createdUser?.name || "",
    },
    {
      Header: "Loại",
      accessor: (item) => item?.action || "",
    },

    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setWatchHistory(item.data);
                        reviewHistoryMethod.reset(item.data)
                        toggle("watchHistory");
                      }}
                    >
                      <Icon
                        name={'eye'}
                      ></Icon>
                      <span>
                        Xem lại
                      </span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  const ingredientPriceHistoryOptions = useMemo(() => {
    if (!watchHistory?.ingredientPriceHistoryId) {
      return []
    }
    return [
      {
        label: renderLabelIngredientPriceHistoryOption(watchHistory.ingredientPriceHistory),
        value: watchHistory.ingredientPriceHistoryId,
        data: watchHistory.ingredientPriceHistory,
      },
    ]
  }, [watchHistory]);
  return (
    <div className="mt-4">

      <BlockHead>
        <BlockHeadContent>
          <BlockTitle tag="h5">Lịch sử</BlockTitle>
        </BlockHeadContent>
      </BlockHead>
      <Block>
        <Table
          notShowPagi
          columns={colTable}
          data={billHistory}
        ></Table>
      </Block>

      <Modal style={{ width: '80vw', maxWidth: '80vw' }} isOpen={view.watchHistory} toggle={() => onFormCancel()}>
        <ModalBody>
          <FormProvider {...reviewHistoryMethod}>
            {watchHistory ? <BillOtherCreateForm
              disabledForm={true}
              id={watchHistory.id}
              duplicateId={null}
              billData={watchHistory}
              setLoading={() => { }}
            /> : <></>}
          </FormProvider>
        </ModalBody>
      </Modal>

    </div>
  );
}

export default BillOtherHistory;
